// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"716":"f2f1eaf5","788":"06341ed2"}[chunkId] + ".chunk.css";
};